// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_9d7b1418","outerContainer":"_2bf7ef4b","secondaryToolbar":"f03914be","doorHangerRight":"c8885158","toolbarContainer":"b123e600","toolbarViewerMiddle":"_5abf2db1","progressBar":"_1dcba7de","back-to-application":"_49ca8eed","modalWrapper":"_107abe40","loader":"_00ada363","title":"_9794b9d7","contentText":"cb43fe2a","textField":"_81d36b36","errorBlock":"b2f0452a","getPasscodeBtn":"_4a05f381","cancelBtn":"_8e47151e"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OtpModal/index.styl
// module id = 5021
// module chunks = 39